module.exports = __webpack_public_path__ + "static/media/42.763f0c14.png";